import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import Select from 'react-select'

import Search from 'pages/Parts/Search'
import Pagination from 'pages/Parts/Pagination'

import { PGET, GET, POST, DELETE } from 'helpers/api'
import { formatDate, formatMoney, formatDateWithTime } from 'helpers/helpers'
import * as XLSX from 'xlsx'

function Index() {
	const URL = '/services/admin/api/pos-payment-pageList'
	const { t } = useTranslation()

	const paymentTypes = [
		{ 'id': 1, 'name': t('CASH') },
		{ 'id': 2, 'name': t('MONEY_TRANSFER') },
		{ 'id': 3, 'name': t('TRANSFER') }
	]

	const settings = useSelector(state => state.settings)
	const [pageCount, setPageCount] = useState(0)
	const [totalCount, setTotalCount] = useState(0)
	const [modalPayment, setModalPayment] = useState(false)
	const [modalPaymentHistory, setModalPaymentHistory] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [data, setData] = useState([])
	const [payments, setPayments] = useState([])
	const [managerMap, setManagerMap] = useState(new Map());
	const [timeFilter, setTimeFilter] = useState('thisMonth'); // or 'allTime'
	const [pageSize, setPageSize] = useState(20)

	function selectItem(item) {
		var itemCopy = { ...item }
		itemCopy.posId = itemCopy.id
		itemCopy.amountIn = ""
		itemCopy.paymentMethod = 3
		itemCopy.note = ""
		setSelectedItem(itemCopy)
	}

	async function payment(e) {
		e.preventDefault();

		var selectedItemCopy = { ...selectedItem }

		var sendData = {}
		sendData.posId = selectedItemCopy.posId
		sendData.amountIn = selectedItemCopy.amountIn
		sendData.paymentMethod = selectedItemCopy.paymentMethod
		sendData.note = selectedItemCopy.note

		var response = await POST('/services/admin/api/pos-payment', sendData, { loader: true })

		if (response) {
			showPaymentModal(false)
			getData()
		}
	}

	function showPaymentModal(bool) {
		if (!bool) {
			var selectedItemCopy = { ...selectedItem }
			selectedItemCopy.posId = null
			selectedItemCopy.amountIn = ""
			selectedItemCopy.paymentMethod = 3
			selectedItemCopy.note = ''
		}

		if (!selectedItem?.id) {
			toast.warning(t('NO_POS_SELECTED'))
			return
		}

		setModalPayment(bool)
	}

	async function showPaymentHistoryModal(bool, posId) {
		if (!bool) {
			setModalPaymentHistory(bool)
			return;
		}
		const response = await GET('/services/admin/api/pos-payment-history/' + posId, {}, { loader: true })
		setPayments(response)
		setModalPaymentHistory(bool)
	}

	async function getData() {
		const filterParams = { size: pageSize };

		if (timeFilter === 'thisMonth') {
			const now = new Date();
			const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
			firstDay.setDate(firstDay.getDate() + 1);
			const tomorrow = new Date(now);
			tomorrow.setDate(tomorrow.getDate() + 1);

			filterParams.fromDate = firstDay.toISOString().split('T')[0];   // yyyy-MM-dd
			filterParams.toDate = tomorrow.toISOString().split('T')[0];     // yyyy-MM-dd (tomorrow)
		}

		const response = await PGET(URL, filterParams, { loader: true });

		if (response) {
			setTotalCount(Math.ceil(response.headers['x-total-count']))
			setPageCount(Math.ceil(response.headers['x-total-count'] / pageSize));

			const updatedData = response.data.map(item => {
				if (item.managerId !== 0 && managerMap.has(item.managerId)) {
					return { ...item, managerId: managerMap.get(item.managerId) };
				} else {
					return { ...item, managerId: "admin" };
				}
			});

			setData(updatedData);
		}
	}



	async function getManagerData() {
		const response = await PGET('/services/uaa/api/manager-allList', {}, { loader: true })
		if (response) {
			const newManagerMap = new Map();
			response.data.forEach(user => {
				if (user.userLogin) {
					if (user.lastName) {
						newManagerMap.set(user.id, user.firstName + " " + user.lastName);
					} else {
						newManagerMap.set(user.id, user.firstName);
					}
				}
			});
			setManagerMap(newManagerMap);
		}
	}

	async function paginate(data) {
		const filterParams = { page: data.selected, size: pageSize };
	
		if (timeFilter === 'thisMonth') {
			const now = new Date();
			const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
			firstDay.setDate(firstDay.getDate() + 1);
			const tomorrow = new Date(now);
			tomorrow.setDate(tomorrow.getDate() + 1);
	
			filterParams.fromDate = firstDay.toISOString().split('T')[0];   // yyyy-MM-dd
			filterParams.toDate = tomorrow.toISOString().split('T')[0];     // yyyy-MM-dd
		}
	
		const response = await PGET(URL, filterParams, { loader: true });
	
		if (response) {
			const updatedData = response.data.map(item => {
				if (item.managerId !== 0 && managerMap.has(item.managerId)) {
					return { ...item, managerId: managerMap.get("" + item.managerId) };
				} else {
					return { ...item, managerId: "admin" };
				}
			});
			setData(updatedData);
		}
	}	

	async function search(data, searchValue) {
		var updatedData = data.map(item => {
			if (item.managerId !== 0 && managerMap.has(item.managerId)) {
				return { ...item, managerId: managerMap.get(item.managerId) };
			} else {
				return { ...item, managerId: "admin" };
			}
		});
		setData(updatedData);
		if (searchValue.length > 0) {
			setPageCount(0)
		}
	}

	useEffect(() => {
		getManagerData();
	}, []); // once on mount

	useEffect(() => {
		getData();
	}, [timeFilter, pageSize]); // re-run when timeFilter or pageSize changes





	function deleteItem(deleteId) {
		DELETE('/services/admin/api/pos-payment?id=' + deleteId).then(() => {
			getData();
		});
	}

	function handlePageSizeChange(selectedOption) {
		setPageSize(selectedOption.value)
	}

	const pageSizeOptions = [
		{ value: 20, label: '20' },
		{ value: 50, label: '50' },
		{ value: 100, label: '100' },
		{ value: 500, label: '500' },
		{ value: 1000, label: '1000' }
	]

	// Excel export function
	function exportToExcel() {
		// Helper function to safely format dates
		const safeFormatDate = (dateValue) => {
			if (!dateValue) return '';
			try {
				return formatDate(dateValue);
			} catch (error) {
				console.warn('Invalid date value:', dateValue, error);
				return '';
			}
		}

		// Prepare data for Excel
		const excelData = data.map((item, index) => ({
			'№': item.rowNum || index + 1,
			[t('OWNER')]: item.ownerLogin || '',
			[t('POS')]: item.id || '',
			[t('SALE_POINT_NAME')]: item.name || '',
			[t('CUSTOMER_CREATOR')]: item.managerId || '',
			[t('DATE_OF_CREATION')]: safeFormatDate(item.createdDate),
			[t('AMOUNT')]: item.amountIn ? formatMoney(item.amountIn) : '',
			[t('MONTHLY_PAYMENT')]: item.monthlyPayment ? formatMoney(item.monthlyPayment) : ''
		}))

		// Create workbook and worksheet
		const ws = XLSX.utils.json_to_sheet(excelData)
		const wb = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(wb, ws, t('PAYMENTS'))

		// Generate Excel file and download
		XLSX.writeFile(wb, `${t('PAYMENTS')}_${new Date().toLocaleDateString()}.xlsx`)
	}


	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('PAYMENTS')} ({totalCount})
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary me-2" onClick={exportToExcel}>
						<i className="uil uil-file-export me-2"></i>
						Excel
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex mb-3">
						<div className="me-2">
							<Search url={URL} search={search} getData={getData}></Search>
						</div>
						<div className="me-2" style={{ minWidth: '120px' }}>
							<Select
								options={pageSizeOptions}
								value={pageSizeOptions.find(option => option.value === pageSize)}
								onChange={handlePageSizeChange}
								placeholder="Page Size"
								isSearchable={false}
							/>
						</div>
						<div className="me-2">
							<Select
								className="w-250px"
								classNamePrefix="react-select"
								options={[
									{ value: 'thisMonth', label: t('THIS_MONTH') },
									{ value: 'allTime', label: t('ALL_TIME') }
								]}
								value={{ value: timeFilter, label: t(timeFilter === 'thisMonth' ? 'THIS_MONTH' : 'ALL_TIME') }}
								onChange={(option) => setTimeFilter(option.value)}
								getOptionLabel={(e) => e.label}
								getOptionValue={(e) => e.value}
							/>
						</div>
						<div>
							<button className="btn btn-outline-primary btn-wide me-2" onClick={showPaymentModal}>
								{t('PAY')}
							</button>
						</div>
					</div>
					<div className="table-responsive">
						<table className="table mb-0">
							<thead>
								<tr>
									<th>№</th>
									<th>{t('OWNER')}</th>
									<th>{t('POS')}</th>
									<th>{t('SALE_POINT_NAME')}</th>
									<th className="text-center">{t('CUSTOMER_CREATOR')}</th>
									<th className="text-center">{t('DATE_OF_CREATION')}</th>
									<th className="text-center">{t('AMOUNT')}</th>
									<th className="text-center">{t('MONTHLY_PAYMENT')}</th>
									<th className="text-center">{t('ACTIONS')}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
										<tr className={'tr-middle ' + ((selectedItem && selectedItem.id === item.id) ? 'table-tr-active' : '')}
											key={index} onClick={() => selectItem(item)}>
											<td>{item.rowNum}</td>
											<td>{item.ownerLogin}</td>
											<td>{item.id}</td>
											<td>{item.name}</td>
											<td>{item.managerId}</td>
											<td className="text-center">{formatDate(item.createdDate)}</td>
											<td className="text-center">{formatMoney(item.amountIn)}</td>
											<td className="text-center">{formatMoney(item.monthlyPayment)}</td>
											<td className="text-center">
												<div className="table-action-button table-action-danger-button" onClick={(e) => { e.stopPropagation(); deleteItem(item.paymentId); }}>
													<i className="uil uil-trash-alt"></i>
												</div>
											</td>
										</tr>
									))}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate}></Pagination>
				</div>
			</div>

			{/* PAYMENT */}
			<Modal show={modalPayment} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => showPaymentModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('PAY')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<span>{t('OWNER')}</span>
						<span>{selectedItem.ownerLogin}</span>
					</div>
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<span>{t('POS')}</span>
						<span>{selectedItem.name}</span>
					</div>
					<form onSubmit={payment} autoComplete="off">
						<div className="form-group">
							<label>{t('PAYMENT_METHOD')}</label>
							<Select
								options={paymentTypes}
								value={paymentTypes.find(option => option.id === selectedItem.paymentMethod)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'paymentMethod': option.id })}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('AMOUNT')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" name="amountIn" autoFocus required
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amountIn': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('NOTE')}</label>
							<input type="text" className="form-control" name="note"
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => showPaymentModal(false)} tabIndex="-1">{t('CANCEL')}</button>
							<button type="submit" className="btn btn-success w-100" disabled={!selectedItem.amountIn}>
								{t('SAVE')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* PAYMENT */}

			{/* PAYMENT HISTORY */}
			<Modal show={modalPaymentHistory} animation={false} centered size="lg"
				dialogClassName="update-modal-width" backdrop="static" onHide={() => showPaymentHistoryModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('HISTORY')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table mb-0">
							<thead>
								<tr>
									<th>{t('TYPE')}</th>
									<th>{t('NOTE')}</th>
									<th>Создал</th>
									<th>Оплата</th>
									<th className="text-center">{t('DATE')}</th>
								</tr>
							</thead>
							<tbody>
								{payments.map((item, index) => (
									<tr key={index}>
										<td>{item.paymentTypeName}</td>
										<td>{item.note}</td>
										<td>{item.createdBy}</td>
										<td>
											<div className="text-nowrap">
												{formatMoney(item.amountIn)}
											</div>
										</td>
										<td>
											<div className="text-nowrap">
												{formatDateWithTime(item.createdDate)}
											</div>
										</td>
									</tr>
								))
								}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* PAYMENT HISTORY */}
		</>
	)
}

export default Index
